import React from 'react'

function DashBoard() {
    return (
        <div>
            <h1>Dashboard</h1>
        </div>
    )
}

export default DashBoard
